export const initialState = {
  transfers: []
};
